var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBigplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4442 25.1429H24.7776V32H22.5553V25.1429H15.8887V22.8571H22.5553V16H24.7776V22.8571H31.4442V25.1429Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigplus);
export default __webpack_public_path__ + "static/media/icon_bigplus.89369ddc579dcac800669fab2826e460.svg";
export { ForwardRef as ReactComponent };